import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetNewTitleBucketsQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	newTitlesFilter?: Types.Maybe<Types.TitleFilter>;
	newAfterCursor?: Types.Maybe<Types.Scalars['String']>;
	first?: Types.Scalars['Int'];
	priceDrops: Types.Scalars['Boolean'];
	bucketSize?: Types.Scalars['Int'];
	groupBy?: Types.NewTitleAggregation;
	pageType?: Types.NewPageType;
}>;

export type GetNewTitleBucketsQuery = { __typename?: 'Query' } & {
	newTitleBuckets: { __typename?: 'NewTitleBucketsConnection' } & {
		pageInfo: { __typename?: 'PageInfo' } & Pick<
			Types.PageInfo,
			'startCursor' | 'endCursor' | 'hasPreviousPage' | 'hasNextPage'
		>;
		edges?: Types.Maybe<
			Array<
				{ __typename?: 'NewTitleBucketsEdge' } & {
					key:
						| ({ __typename?: 'DatePackageAggregationKey' } & Pick<
								Types.DatePackageAggregationKey,
								'date'
						  > & {
									package: { __typename?: 'Package' } & Pick<
										Types.Package,
										'id' | 'packageId' | 'shortName'
									>;
								})
						| { __typename?: 'DateAggregationKey' }
						| ({ __typename?: 'BucketPackageAggregationKey' } & Pick<
								Types.BucketPackageAggregationKey,
								'bucketType'
						  > & {
									package: { __typename?: 'Package' } & Pick<
										Types.Package,
										'id' | 'packageId' | 'shortName'
									>;
								})
						| { __typename?: 'BucketAggregationKey' };
					node: { __typename?: 'NewTitlesConnection' } & Pick<Types.NewTitlesConnection, 'totalCount'> & {
							pageInfo: { __typename?: 'PageInfo' } & Pick<
								Types.PageInfo,
								'endCursor' | 'hasNextPage' | 'hasPreviousPage'
							>;
						};
				}
			>
		>;
	};
};

export const GetNewTitleBucketsDocument = gql`
	query GetNewTitleBuckets(
		$country: Country!
		$newTitlesFilter: TitleFilter
		$newAfterCursor: String
		$first: Int! = 2
		$priceDrops: Boolean!
		$bucketSize: Int! = 8
		$groupBy: NewTitleAggregation! = DATE_PACKAGE
		$pageType: NewPageType! = NEW
	) {
		newTitleBuckets(
			country: $country
			filter: $newTitlesFilter
			after: $newAfterCursor
			first: $first
			bucketSize: $bucketSize
			priceDrops: $priceDrops
			pageType: $pageType
			groupBy: $groupBy
		) {
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			edges {
				key {
					... on DatePackageAggregationKey {
						date
						package {
							id
							packageId
							shortName
						}
					}
					... on BucketPackageAggregationKey {
						bucketType
						package {
							id
							packageId
							shortName
						}
					}
				}
				node {
					totalCount
					pageInfo {
						endCursor
						hasNextPage
						hasPreviousPage
					}
				}
			}
		}
	}
`;
